<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon large v-bind="attrs" v-on="on">
        <v-icon>mdi-camera</v-icon></v-btn
      >
    </template>
    <v-card>
      <v-card-title class="d-flex justify-space-between">
        <span class="text-h5">Upload Picture</span>
        <v-btn color="var(--red)" x-large icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form @submit.prevent="uploadImage">
          <v-file-input
            v-model="image"
            :rules="profilePictureUploadRules"
          ></v-file-input>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialog = false">
          Close
        </v-btn>
        <v-btn color="blue darken-1" text @click="dialog = false"> Save </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    image: null,
    profilePictureUploadRules: [
      (value) =>
        !value ||
        value.size < 2000000 ||
        "Avatar size should be less than 2 MB!",
    ],
  }),
  methods: {
    uploadImage() {
      console.log("uploaded");
    },
  },
};
</script>

<style>
</style>